/**
 * Sprachbereiche /en und /nl: dieselben Seiten-Komponenten (pages/intl), Texte je Sprache in einem eigenen Paket.
 * <LocaleProvider lang="nl"> lädt "@/nl/content" erst bei Bedarf (eigener Chunk, die deutschen Seiten laden ihn nie);
 * useLocale() wartet per Suspense, bis die Texte da sind. Seite und Texte laden dabei parallel.
 */
import React, { createContext, useContext } from "react";

const LOADERS = {
  en: () => import("@/en/content"),
  nl: () => import("@/nl/content"),
};

const cache = {};
function load(lang) {
  if (!cache[lang]) {
    const entry = { status: "pending", value: null, error: null };
    entry.promise = (LOADERS[lang] || LOADERS.en)().then(
      (m) => { entry.status = "done"; entry.value = m; },
      (e) => { entry.status = "error"; entry.error = e; delete cache[lang]; },
    );
    cache[lang] = entry;
  }
  return cache[lang];
}

const LocaleContext = createContext("de"); // ohne Provider = deutsche Seiten

export function LocaleProvider({ lang, children }) {
  load(lang); // sofort anstoßen, nicht erst wenn die Seite rendert
  return <LocaleContext.Provider value={lang}>{children}</LocaleContext.Provider>;
}

/** Sprache der Seite: "de" (ohne Provider), "en" oder "nl". Für Bausteine, die deutsche und fremdsprachige Seiten teilen. */
export function useLang() {
  return useContext(LocaleContext);
}

/** Texte und Helfer der aktuellen Sprache (Modul-Namespace von en/content.js bzw. nl/content.js). */
export function useLocale() {
  const lang = useContext(LocaleContext);
  const e = load(lang);
  if (e.status === "pending") throw e.promise;
  if (e.status === "error") throw e.error;
  return e.value;
}
